<div class="toaster-container" *ngIf="showToaster">
    <div class="toaster" [style.background-color]="backgroundColor">
        <p>{{ message | translate }}</p>
        <i class="icon-close-default-16" (click)="close()"></i>
    </div>
</div>
